const HTML_ESCAPES = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  "\"": "&quot;",
  "'": "&#039;",
};

// Art keys come from remote game state and land inside a class attribute, so they
// are allow-listed rather than escaped.
const SAFE_ART_KEY = /^[a-z0-9-]{1,32}$/;

export function escapeHtml(value) {
  if (value === null || value === undefined) return "";
  return String(value).replace(/[&<>"']/g, (char) => HTML_ESCAPES[char]);
}

export function artClass(image) {
  return SAFE_ART_KEY.test(String(image ?? "")) ? `art art-${image}` : "art";
}

export function initials(name) {
  return String(name ?? "")
    .split(/\s+/)
    .map((part) => part.replace(/[^\p{L}\p{N}]/gu, "")[0] || "")
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

// Counters rendered into markup are only ever numbers. Remote state is not trusted
// to honour that, so anything else collapses to 0 instead of reaching innerHTML.
export function numberText(value) {
  const number = Number(value);
  return Number.isFinite(number) ? String(number) : "0";
}
